import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quote-block',
  templateUrl: './quote-block.component.html',
  styleUrls: ['./quote-block.component.scss']
})
export class QuoteBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
